<template>
  <div class="history">
    <PageHeader title="Marketplace" v-loading.fullscreen.lock="loading"></PageHeader>
    <History v-if="!loading"
             :history="history()"
             :title="$t('history.title')"
             @bubbleUpRefreshHistory="refreshHistory"></History>
  </div>
</template>

<script>
  import History from '../../../components/History/History.vue';
  import PageHeader from '../../../components/PageHeader/PageHeader.vue';

  export default {
    components: {
      History,
      PageHeader,
    },
    data() {
      return {
        loading: true,
      };
    },
    async created() {
      await this.$store.dispatch('history/list', this.shopId);
      this.$store.dispatch('shopAuth/getShopInfo', this.shopId)
        .then(() => {
          this.loading = false;
        });
    },
    computed: {
      shopId() {
        return this.$store.getters['shopAuth/currentShopId'];
      },
    },
    methods: {
      history() {
        return this.$store.getters['history/history'];
      },
      refreshHistory() {
        this.loading = true;
        this.$store.dispatch('history/list', this.shopId)
          .then(() => {
            this.loading = false;
          });
        this.$store.dispatch('shopAuth/getShopInfo', this.shopId);
      },
    },
  };

</script>

<style lang="stylus">

</style>
